export const validation = {
  titleMaxChar: 50,
  paragraphMaxChar: 250,
  title: { required: true },
  blocks: {
    min: 1,
    max: 4
  }
}
